@if (isLoading) {
  <app-main-loader-lottie> </app-main-loader-lottie>
} @else {
  <form class="settings-fields-container" [formGroup]="formGroup">
    <div class="content" [ngClass]="fieldsAreaClasses">
      <div class="fields-area">
        <div class="settings-header-row">
          <span class="title">International Settings</span>
        </div>
        <div class="settings-row is-active-row">
          <span class="is-active-txt">Enable international shipping</span>
          <pdq-slide-toggle
            formControlName="isActiveInternational"
            [(ngModel)]="isActiveInternational"></pdq-slide-toggle>
        </div>
        @if (isActiveInternational) {
          <app-incoterm
            [form]="formGroup"
            [dirty]="isDirty"
            [dynamicFields]="internationalSettingsShopDynamicFields"></app-incoterm>
          <app-tax [form]="formGroup" [dirty]="isDirty"></app-tax>
        }
      </div>
    </div>
    <footer [ngClass]="footerStateClasses">
      <span>{{ changedStatusTxt }}</span>
      <pdq-button variant="secondary" (click)="resetForm()" label="cancel" class="action-btn">cancel</pdq-button>
      <pdq-button
        variant="primary"
        type="submit"
        label="save"
        class="action-btn"
        [disabled]="!isValid"
        (click)="onSubmit()"
        >save</pdq-button
      >
    </footer>
  </form>
}
